import { IQuerySearch } from './../interfaces/query-search.interface';
export class QuerySearch implements IQuerySearch {
  [x: string]: unknown;
}
